import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useChartData } from '../../../stores/appointment/appointment.store';

export const EMCodeContainer: FC = () => {
  const { chartData } = useChartData();
  const { t } = useTranslation();

  const emCode = chartData?.emCode;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, width: '100%' }}>
      <Typography variant="h5" color="primary.dark">
        {t('telemed.review.emCode.title')}
      </Typography>
      <Typography>{emCode?.display}</Typography>
    </Box>
  );
};
